import { FC, useEffect } from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";

import { salsaSelector } from "redux/selectors";
import { SalsaOnboardingStatus } from "types/BETypes";

import { UserResponseDto } from "utils/swagger_react_query";

import { BCLeft, BCRight, ButtonsContainer, ContinueButton } from "../styles";
import { Container, FrameContainer } from "./styles";

interface Props {
  parentTranslationPrefix: string;
  currentUser: UserResponseDto;
  className?: string;
  onContinue: () => void;
  onSalsaOnboardingComplete: () => void;
}

const SetupPayroll: FC<Props> = ({
  parentTranslationPrefix,
  className,
  currentUser,
  onContinue,
  onSalsaOnboardingComplete,
}) => {
  const translationPrefix = `${parentTranslationPrefix}.steps.setup_payroll`;

  const salsaData = useSelector(salsaSelector);
  const { salsa: salsaInstance, authToken: authToken } = salsaData || {};
  const salsaFrameName = "worker-onboarding";
  const salsaFrameId = "onboard-container";
  const frameSelector = `#${salsaFrameId}`;
  const isOnboardingConfirmed =
    currentUser?.salsaOnboardingStatus === SalsaOnboardingStatus.COMPLETED;

  useEffect(() => {
    if (currentUser?.userId && salsaData?.salsa) {
      const salsaElement = salsaInstance.elements.create(salsaFrameName, {
        userToken: authToken,
        workerId: currentUser.salsaWorkerId,
      });

      salsaInstance.elements.mount(salsaElement, frameSelector);
      salsaElement.on("complete", () => {
        onSalsaOnboardingComplete();
      });

      return () => {
        salsaInstance.elements.destroy(salsaElement);
      };
    }
  }, [salsaData?.salsa, currentUser]);

  const isContinueDisabled = currentUser?.salsaOnboardingStatus !== SalsaOnboardingStatus.COMPLETED;

  return (
    <Container className={className}>
      <FrameContainer id={salsaFrameId} isOnboardingConfirmed={isOnboardingConfirmed} />
    </Container>
  );
};

export default SetupPayroll;
